/** Normalizes a user-entered anchor into a valid HTML id (lowercase, hyphenated, no leading #). */
export function slugifyAnchorId(value: string): string {
  return value
    .trim()
    .replace(/^#+/, "")
    .toLowerCase()
    .normalize("NFD")
    .replaceAll(/\p{M}/gu, "")
    .replaceAll(/[^a-z0-9]+/g, "-")
    .replaceAll(/(^-|-$)/g, "");
}

/** Returns the anchor id from a hash href, or null when the href is not an in-page anchor. */
export function resolveAnchorTarget(href: string): string | null {
  if (!href?.startsWith("#")) return null;
  const id = slugifyAnchorId(href);
  return id || null;
}
